import House5 from "../../assets/homepage/House5.jpeg";
import { BsWhatsapp } from "react-icons/bs";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const contactItems = [
  {
    icon: <BsTelephoneFill className="text-[#1877F2] text-xl" />,
    label: "Call Us",
    value: "09033020343",
    href: "tel:+2349033020343",
  },
  {
    icon: <BsWhatsapp className="text-[#25D366] text-xl" />,
    label: "WhatsApp",
    value: "+234 903 302 0343",
    href: "https://wa.me/+2349033020343",
    external: true,
  },
  {
    icon: <MdEmail className="text-[#1877F2] text-xl" />,
    label: "Email",
    value: "info@perfectshelters.com",
    href: "mailto:info@perfectshelters.com",
  },
];

function ContactUs() {
  return (
    <section className="bg-gray-50 py-16 md:py-24 font-Montserrat">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">

          {/* Image */}
          <div className="md:w-1/2 w-full relative">
            <img
              src={House5}
              alt="Beautiful home built by Perfect Shelters"
              className="w-full h-[280px] md:h-[480px] object-cover rounded-2xl shadow-xl"
            />
            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-3 md:-right-6 bg-[#1877F2] text-white rounded-xl px-5 py-4 shadow-lg">
              <p className="text-2xl md:text-3xl font-bold">10+</p>
              <p className="text-xs md:text-sm font-medium opacity-90">Years of Excellence</p>
            </div>
          </div>

          {/* Text */}
          <div className="md:w-1/2 w-full mt-6 md:mt-0">
            <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
              Get in Touch
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 leading-snug">
              Ready to build your<br className="hidden md:block" /> dream home?
            </h2>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed mb-8">
              Our client-driven approach spans every stage — from initial
              concept and design, to materials sourcing and construction. Reach
              out and let's start building together.
            </p>

            {/* Contact items */}
            <div className="flex flex-col gap-4 mb-8">
              {contactItems.map(({ icon, label, value, href, external }) => (
                <a
                  key={label}
                  href={href}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noopener noreferrer" : undefined}
                  className="flex items-center gap-4 group"
                >
                  <div className="w-11 h-11 bg-white rounded-full shadow-sm flex items-center justify-center flex-shrink-0 group-hover:shadow-md transition-shadow">
                    {icon}
                  </div>
                  <div>
                    <p className="text-xs text-gray-400 uppercase tracking-wide">{label}</p>
                    <p className="text-gray-800 font-semibold text-sm md:text-base group-hover:text-[#1877F2] transition-colors">
                      {value}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* CTA buttons */}
            <div className="flex flex-wrap gap-3">
              <a
                href="https://wa.me/+2349033020343"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-7 rounded-full transition-colors duration-200 text-sm"
              >
                <BsWhatsapp />
                Chat on WhatsApp
              </a>
              <Link
                to="/featured-house-plans"
                className="inline-block border-2 border-[#1877F2] text-[#1877F2] hover:bg-[#1877F2] hover:text-white font-semibold py-3 px-7 rounded-full transition-colors duration-200 text-sm"
              >
                Browse Plans
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ContactUs;
